import type { NavItem } from "@/types";

export const getNavItems = (t: (key: string) => string): NavItem[] => [
  {
    name: t("sidebar.home"),
    href: "/",
    icon: "ic:round-home",
    roles: ["User"],
  },
  {
    name: t("sidebar.billing"),
    href: "/billing",
    icon: "ic:round-payment",
    roles: ["User"],
  },
  {
    name: t("sidebar.company"),
    href: "/company",
    icon: "ic:round-business",
    roles: ["User"],
  },
  {
    name: t("sidebar.admin"),
    icon: "ic:round-admin-panel-settings",
    roles: ["Admin"],
    subItems: [
      { name: t("sidebar.subscriptions"), href: "/admin/subscriptions" },
      { name: t("sidebar.deployments"), href: "/admin/deployments" },
      { name: t("sidebar.users"), href: "/admin/settings/users" },
      { name: t("sidebar.roles"), href: "/admin/settings/roles" },
      { name: t("sidebar.auditLogs"), href: "/admin/settings/audit-logs" },
    ],
  },
];
